import {stripDisallowedPlateChars, trimPlateSeparators} from 'features/vin-validate';

export function handleRegistrationPlateBlur(e: React.FocusEvent<HTMLInputElement>) {
  const input = e.currentTarget;
  const currentValue = input.value;

  // Upper-case first: stripDisallowedPlateChars is case-insensitive and preserves case, so
  // lowercase values injected via autofill/accessibility tools (which bypass the keydown filter)
  // must be normalised here to match the persisted value produced by the Zod schema.
  const normalizedValue = trimPlateSeparators(
    stripDisallowedPlateChars(currentValue.toUpperCase())
  );

  if (normalizedValue === currentValue) {
    return;
  }

  input.setRangeText(normalizedValue, 0, currentValue.length, 'end');

  input.dispatchEvent(new Event('input', {bubbles: true}));
}
